export default __webpack_public_path__ + "static/media/mail.01785427.svg";